define('models/merchants/consumermerchantlocation',[
    'backbone',
    'models/merchants/businesshours_collection',
    'models/merchants/businesshours/businesshour'
], function(Backbone, BusinessHoursCollection, BusinessHour){
    var ConsumerMerchantLocation = Backbone.Model.extend({
        url: function(){
            if(this.MerchantGUID){
                return pf.consumerURL + "/Merchants/" + this.MerchantGUID;
            } else {
                return pf.merchantsURL + "/Groups/" + this.MerchantGroupGUID + "/Info";
            }
        },
        initialize: function(options){
            options || (options = {});

            if(options.MGN != undefined){
                this.MerchantGroupName = options.MGN;
            } else if(options.GN != undefined){
                this.MerchantGroupName = options.GN;
            }

            this.MerchantGroupGUID = options.MGGD;

            if(options.MGL != undefined){
                this.Logo = options.MGL != null && options.MGL != null ? buildImageURL(pf.enums.entityTypeCodeEnum.Merchant, options.MGGD, pf.enums.imageTypeGUIDEnum.Profile, options.MGL) : null;
            } else if(options.LG != undefined){
                this.Logo = options.LG != null && options.LG != null ? buildImageURL(pf.enums.entityTypeCodeEnum.Merchant, options.MGGD, pf.enums.imageTypeGUIDEnum.Profile, options.LG) : null;
            }

            this.MerchantCategory = options.CAT;
            this.MerchantGUID = options.MGID;
            this.StoreID = options.SID;
            this.LocationName = options.LN;
            this.AddressLine1 = options.ALO;
            this.AddressLine2 = options.AL2;
            this.City = options.CY;
            this.PhoneNumber = options.PH;
            this.State = options.ST;
            this.StateAbbreviation = options.SA;
            this.ZipCode = options.ZC;
            this.Country = options.C;
            this.ShortDescription = options.SD;
            this.ZipCodeID = options.ZID;
            this.CountryID = options.CID;
            this.LocationType = options.LT;
            this.LocationTypeID = options.LTID;
            this.Latitude = options.LAT;
            this.Longitude = options.LON;
            this.RebatePercentage = options.RB;
            this.CurrentRebatePercentage = options.CRP;
            this.NextRebatePercentage = options.NRP;
            this.CurrentRebateIsPromo = options.CRIP;
            this.NextRebateIsPromo = options.NRIP;
            this.NextRebateTime = options.NRT;
            this.NextRebateDisplayTimeOnly = options.NRDTO;
            this.WebsiteURL = options.WURL;
            this.ExternalURL = options.EU;
            this.FacebookURL = options.FURL;
            this.TwitterAddress = options.TA;
            this.MenuURL = options.MURL;
            this.EvergreenRebatePercentage = options.ERP;
            this.LocationShortDescription = options.LSD;

            this.AffiliateUrl = options.AURL;
            this.PopularityIndex = options.PTI;            
            this.CreatedDT = options.CDT;
            this.AggregatorID = options.AGID;
            this.Distance = options.DI;

            this.HideRebate = options.HR;

            this.HoursOfOperation = new BusinessHoursCollection(options.HOP, { parse: true });
            
            if(isEmpty(options.BH)){
                this.BusinessHours = null;
            } else {
                this.BusinessHours = new BusinessHour(options.BH, { parse: true });
            }

            
        },
        parse: function(data){
            var response = {};

            if (data.MGN != undefined)
                response.MerchantGroupName = data.MGN;
            else if (data.GN != undefined)
                response.MerchantGroupName = data.GN;

            if (data.MGL != undefined)                
                response.Logo = data.MGL != null && data.MGL != null ? buildImageURL(pf.enums.entityTypeCodeEnum.Merchant, data.MGGD, pf.enums.imageTypeGUIDEnum.Profile, data.MGL) : null;
            else if (data.LG != undefined)
                response.Logo = data.LG != null && data.LG != null ? buildImageURL(pf.enums.entityTypeCodeEnum.Merchant, data.MGGD, pf.enums.imageTypeGUIDEnum.Profile, data.LG) : null;               

            response.MerchantCategory = data.CAT;
            response.ShortDescription = data.SD;
            response.MerchantGroupGUID = data.MGGD;
            response.MerchantGUID = data.MGID;
            response.StoreID = data.SID;
            response.LocationName = data.LN;
            response.AddressLine1 = data.ALO;
            response.AddressLine2 = data.AL2;
            response.City = data.CY;
            response.PhoneNumber = data.PH;
            response.State = data.ST;
            response.StateAbbreviation = data.SA;
            response.ZipCode = data.ZC;
            response.Country = data.C;
            response.ShortDescription = data.SD;
            response.ZipCodeID = data.ZID;
            response.CountryID = data.CID;
            response.LocationType = data.LT;
            response.LocationTypeID = data.LTID;
            response.Latitude = data.LAT;
            response.Longitude = data.LON;
            response.RebatePercentage = data.RB;
            response.CurrentRebatePercentage = data.CRP;
            response.NextRebatePercentage = data.NRP;
            response.CurrentRebateIsPromo = data.CRIP;
            response.NextRebateIsPromo = data.NRIP;
            response.NextRebateTime = data.NRT;
            response.NextRebateDisplayTimeOnly = data.NRDTO;
            response.WebsiteURL = data.WURL;
            response.ExternalURL = data.EU;
            response.FacebookURL = data.FURL;
            response.TwitterAddress = data.TA;
            response.MenuURL = data.MURL;
            response.EvergreenRebatePercentage = data.ERP;
            response.LocationShortDescription = data.LSD;

            response.AffiliateUrl = data.AURL;
            response.PopularityIndex = data.PTI;
            response.CreatedDT = data.CDT;
            response.AggregatorID = data.AGID;
            response.Distance = data.DI;

            response.HideRebate = data.HR;

            response.HoursOfOperation = new BusinessHoursCollection(data.HOP, { parse: true });
            
            if(isEmpty(data.BH)){
                response.BusinessHours = null;
            } else {
                response.BusinessHours = new BusinessHour(data.BH, { parse: true });
            }

            return response;
        }
    });

    return ConsumerMerchantLocation;
});

